interface AppendScriptOptions {
  async?: boolean;
  defer?: boolean;
  onError?: (event: string | Event) => void;
  onLoad?: () => void;
}

const findExistingScript = (scriptToAppend: string): HTMLScriptElement | null =>
  Array.from(document.querySelectorAll<HTMLScriptElement>('script')).find((script) => {
    const currentSrc = script.getAttribute('src');
    return (
      currentSrc === scriptToAppend ||
      script.src === new URL(scriptToAppend, window.location.href).href
    );
  }) || null;

export const appendScript = (scriptToAppend: string, options: AppendScriptOptions = {}) => {
  const existingScript = findExistingScript(scriptToAppend);
  if (existingScript) return existingScript;

  const script = document.createElement('script');

  script.type = 'text/javascript';
  script.src = scriptToAppend;
  script.async = options.async ?? true;
  script.defer = options.defer ?? false;

  if (options.onLoad) {
    script.onload = options.onLoad;
  }

  if (options.onError) {
    script.onerror = options.onError;
  }

  document.body.appendChild(script);

  return script;
};

export const appendAppBanner = () => {
  if (document.querySelector('meta[name="apple-itunes-app"]')) {
    return;
  }
  const meta = document.createElement('meta');
  meta.name = 'apple-itunes-app';
  meta.content = 'app-id=1584079757';
  document.head.appendChild(meta);
};

// Idempotent counterpart to appendAppBanner(). Safe to call whether or not the tag is present, so
// callers can use it unconditionally to converge on "no banner" without checking prior state.
export const removeAppBanner = () => {
  document.querySelector('meta[name="apple-itunes-app"]')?.remove();
};
